import React, { Component } from 'react'
import { IconButton, withStyles } from '@material-ui/core';
import { Check, Cancel, Edit } from '@material-ui/icons';
import Api from '../../api/Api.js';

const styles = /*() =>*/ {
    container: {
        "&:hover": {
            cursor: "pointer",
            backgroundColor: '#f7f7f7',
            borderRadius: 4
        }
    }
}

class EditableLabel extends Component {

    state = {
        editing: false
    }

    submit = () =>
        Api[this.props.method || "post"](this.props.endpoint, this.props.editValue)
            .then(({ data }) => {
                this.props.onSubmitSuccess(data)
                this.setState({ editing: false });
            })
            .catch((e) => console.error(e));

    render() {
        const { classes } = this.props;

        if (this.state.editing) {
            return (
                <div>
                    {this.props.children}
                    {/* Accept | Cancel */}
                    <IconButton onClick={() => this.submit()}>
                        <Check />
                    </IconButton>
                    <IconButton onClick={() => this.setState({ editing: false })}>
                        <Cancel />
                    </IconButton>
                </div>
            );
        } else {
            return (
                <div className={classes.container} onClick={() => this.setState({ editing: true })}>
                    {this.props.label}
                    {this.props.noIcon ?
                        null :
                        <IconButton>
                            <Edit />
                        </IconButton>
                    }
                </div>
            );
        }
    }
}

export default withStyles(styles)(EditableLabel);
